import React, { useEffect, useState } from "react";
import scheduleService from "../../services/schedule.service";

const TitleReport = (props: { scheId: number }) => {
  const { scheId } = props;
  const [sche, setSche] = useState<any>({});
  useEffect(() => {
    (async () => {
      //ดึงข้อมูลกำหนดการทั้งหมดมา โดยเรียงจาก เปิดไว้บน
      await scheduleService.getById(scheId).then((res) => {
        setSche(res.data);
      });
    })();
  }, [scheId]);
  return (
    <div>
      <h3 className="text-start mt-3">
        รายงาน {sche.type === "tqf" ? "มคอ." : "อชว."} | RMUTI ประจำปีการศึกษา{" "}
        {sche.year} ภาคการศึกษาที่ {sche.term}
      </h3>
    </div>
  );
};

export default TitleReport;
